
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    previousPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return {
        tag: 'h4',
        html: this.product.name,
        fontWeight: 'semibold'
      }
    },
    image() {
      return {
        fit: 'contain',
        height: 'lg',
        fillParent: true,
        ...this.product.image
      }
    },
    text() {
      return {
        html: this.product.excerpt,
        fontSize: 'sm',
        textTruncate: { all: false, md: true },
        fontWeight: 'light'
      }
    },
    detailsLink() {
      const products = this.$pagePath('products')
      return `${products}/${this.product.slug}`
    }
  }
}
